import { render, staticRenderFns } from "./NotificationResponseModal.vue?vue&type=template&id=4076e124"
import script from "./NotificationResponseModal.vue?vue&type=script&lang=js"
export * from "./NotificationResponseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports